"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectorContent = exports.SelectorInput = exports.SelectorContainer = void 0;
const theme_1 = require("@pulse-web-ui/theme");
require("./selector.types");
exports.SelectorContainer = theme_1.styled.label ``;
exports.SelectorInput = theme_1.styled.input.attrs({
    type: 'checkbox',
}) `
  display: none;

  &:checked ~ div {
    background: ${({ disabled, theme }) => disabled ? theme.colors.neutral[30] : theme.colors.surface.brand};
    border-color: ${({ disabled, theme }) => disabled ? theme.colors.neutral[30] : theme.colors.surface.brand};

    svg {
      opacity: 1;
    }
  }
`;
exports.SelectorContent = theme_1.styled.div `
  ${theme_1.mixins.flex({
    verticalAlignment: 'center',
    horizontalAlignment: 'center',
})};
  width: 24px;
  height: 24px;
  border-radius: 50%;
  box-sizing: border-box;
  border: 2px solid
    ${({ disabled, error, theme }) => error
    ? theme.colors.accent.error.normal
    : disabled
        ? theme.colors.neutral[70]
        : theme.colors.neutral[50]};
  background: ${({ disabled, theme }) => disabled ? theme.colors.neutral[20] : 'transparent'};
  transition: border-color 0.2s ease-out, background-color 0.2s ease-out;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};

  ${({ disabled, error, theme }) => !disabled &&
    !error &&
    (0, theme_1.css) `
      &:hover {
        border-color: ${theme.colors.surface.brand};
      }
    `}

  svg {
    opacity: 0;
    transition: opacity 0.2s ease-out;
  }
`;
